import { jsx as m } from "react/jsx-runtime";
import i from "./index.es5580.js";
import n from "classnames";
const p = ({
  children: t,
  testId: s,
  isCondensed: e,
  isHugging: o,
  withCTA: r
}) => {
  const a = n(i.container, {
    [i.isCondensed]: e,
    [i.isHugging]: o,
    [i.withCTA]: r
  });
  return /* @__PURE__ */ m("div", { className: a, "data-testid": s, "data-pl-identifier": "primitive-callout", children: t });
};
export {
  p as CalloutPrimitive
};
//# sourceMappingURL=index.es658.js.map
